import { __extends } from "tslib";
import { MethodBase, _Shader_MethodBase } from './MethodBase';
/**
 * EffectFogMethod provides a method to add distance-based fog to a material.
 */
var EffectFogMethod = /** @class */ (function (_super) {
    __extends(EffectFogMethod, _super);
    /**
     * Creates a new EffectFogMethod object.
     * @param minDistance The distance from which the fog starts appearing.
     * @param maxDistance The distance at which the fog is densest.
     * @param fogColor The colour of the fog.
     */
    function EffectFogMethod(minDistance, maxDistance, fogColor) {
        if (minDistance === void 0) { minDistance = 0; }
        if (maxDistance === void 0) { maxDistance = 1000; }
        if (fogColor === void 0) { fogColor = 0x808080; }
        var _this = _super.call(this) || this;
        _this._minDistance = minDistance;
        _this._maxDistance = maxDistance;
        _this._fogColor = fogColor;
        return _this;
    }
    Object.defineProperty(EffectFogMethod.prototype, "assetType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return EffectFogMethod.assetType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EffectFogMethod.prototype, "minDistance", {
        /**
         * The distance from which the fog starts appearing.
         */
        get: function () {
            return this._minDistance;
        },
        set: function (value) {
            this._minDistance = value;
            this.invalidate();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EffectFogMethod.prototype, "maxDistance", {
        /**
         * The distance at which the fog is densest.
         */
        get: function () {
            return this._maxDistance;
        },
        set: function (value) {
            this._maxDistance = value;
            this.invalidate();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EffectFogMethod.prototype, "fogColor", {
        /**
         * The colour of the fog.
         */
        get: function () {
            return this._fogColor;
        },
        set: function (value) {
            this._fogColor = value;
            this.invalidate();
        },
        enumerable: false,
        configurable: true
    });
    EffectFogMethod.assetType = '[asset EffectFogMethod]';
    return EffectFogMethod;
}(MethodBase));
export { EffectFogMethod };
import { ShaderBase } from '@awayjs/renderer';
/**
 * _Shader_EffectFogMethod provides a method to add distance-based fog to a material.
 */
var _Shader_EffectFogMethod = /** @class */ (function (_super) {
    __extends(_Shader_EffectFogMethod, _super);
    function _Shader_EffectFogMethod() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates a new EffectEnvMapChunk.
     */
    _Shader_EffectFogMethod.prototype.init = function (method, shader) {
        _super.prototype.init.call(this, method, shader);
        this._method = method;
        this._shader = shader;
    };
    /**
     * @inheritDoc
     */
    _Shader_EffectFogMethod.prototype._initVO = function (chunkVO) {
        chunkVO.needsProjection = true;
    };
    /**
     * @inheritDoc
     */
    _Shader_EffectFogMethod.prototype._activate = function () {
        if (this._invalid) {
            var data = this._shader.fragmentConstantData;
            var index = this._fogColorIndex;
            var color = this._method.fogColor;
            data[index] = ((color >> 16) & 0xff) / 0xff;
            data[index + 1] = ((color >> 8) & 0xff) / 0xff;
            data[index + 2] = (color & 0xff) / 0xff;
            data[index + 3] = 1;
            data[index + 4] = this._method.minDistance;
            data[index + 5] = 1 / (this._method.maxDistance - this._method.minDistance);
            data[index + 6] = 0;
            data[index + 7] = 0;
        }
    };
    /**
     * @inheritDoc
     */
    _Shader_EffectFogMethod.prototype._getFragmentCode = function (targetReg, registerCache, sharedRegisters) {
        var fogColor = registerCache.getFreeFragmentConstant();
        var fogData = registerCache.getFreeFragmentConstant();
        var temp = registerCache.getFreeFragmentVectorTemp();
        registerCache.addFragmentTempUsages(temp, 1);
        var temp2 = registerCache.getFreeFragmentVectorTemp();
        var code = '';
        this._fogColorIndex = fogColor.index * 4;
        code += 'sub ' + temp2 + '.w, ' + sharedRegisters.projectionFragment + '.z, ' + fogData + '.x\n' +
            'mul ' + temp2 + '.w, ' + temp2 + '.w, ' + fogData + '.y\n' +
            'sat ' + temp2 + '.w, ' + temp2 + '.w\n' +
            'sub ' + temp + ', ' + fogColor + ', ' + targetReg + '\n' + // (fogColor- col)
            'mul ' + temp + ', ' + temp + ', ' + temp2 + '.w\n' + // (fogColor- col)*fogRatio
            'add ' + targetReg + ', ' + targetReg + ', ' + temp + '\n'; // fogRatio*(fogColor- col) + col
        registerCache.removeFragmentTempUsage(temp);
        return code;
    };
    return _Shader_EffectFogMethod;
}(_Shader_MethodBase));
export { _Shader_EffectFogMethod };
ShaderBase.registerAbstraction(_Shader_EffectFogMethod, EffectFogMethod);
